import { useState } from "react";
import { BellOff } from "lucide-react";
import { toast } from "sonner";
import api, { formatApiError } from "@/api/client";

export const REMINDER_OFF_REASONS = ["Client on hold", "Handled offline", "Client not interested", "Waiting on client", "Duplicate entry"];

export const setLeadReminders = async (leadId, off, reason = "") => {
  try {
    const { data } = await api.post(`/hot-leads/${leadId}/reminders`, { off, reason });
    toast.success(off ? "Reminders turned off" : "Reminders turned back on");
    window.dispatchEvent(new Event("lim:nudges-refresh"));
    return data;
  } catch (x) {
    toast.error(formatApiError(x?.response?.data?.detail) || "Failed");
    return null;
  }
};

export function ReminderOffForm({ leadId, onDone, onCancel }) {
  const [reason, setReason] = useState("");
  const [busy, setBusy] = useState(false);
  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    const data = await setLeadReminders(leadId, true, reason.trim());
    setBusy(false);
    if (data) onDone?.(data);
  };
  return (
    <form onSubmit={submit} className="mt-2 space-y-2" data-testid={`reminder-off-form-${leadId}`}>
      <div className="text-xs text-white/60">Why stop reminders for this lead? (stops for everyone)</div>
      <div className="flex flex-wrap gap-1.5">
        {REMINDER_OFF_REASONS.map((r, i) => (
          <button key={r} type="button" onClick={() => setReason(r)} data-testid={`reminder-off-reason-${leadId}-${i}`}
            className={`h-7 px-2 rounded-full border text-[11px] transition-colors ${reason === r ? "border-[#E11D2E] bg-[#E11D2E]/10 text-[#E11D2E]" : "border-white/15 hover:bg-white/5"}`}>{r}</button>
        ))}
      </div>
      <input value={reason} onChange={(e) => setReason(e.target.value)} placeholder="Or type a reason…" data-testid={`reminder-off-input-${leadId}`}
        className="w-full h-8 rounded-md border border-white/15 bg-transparent px-2 text-sm focus:outline-none focus:ring-2 focus:ring-[#E11D2E]/30" />
      <div className="flex gap-2">
        <button type="submit" disabled={busy || reason.trim().length < 2} data-testid={`reminder-off-save-${leadId}`}
          className="h-8 px-3 rounded-md bg-[#E11D2E] hover:bg-[#F03041] text-white text-xs font-semibold disabled:opacity-50 inline-flex items-center gap-1"><BellOff size={12} /> Stop reminders</button>
        <button type="button" onClick={onCancel} data-testid={`reminder-off-cancel-${leadId}`} className="h-8 px-3 rounded-md border border-white/15 text-xs">Back</button>
      </div>
    </form>
  );
}
